import { takeLatest, call, put } from 'redux-saga/effects';
import Cookies from 'js-cookie';
import { getUpperLevelDomain, parseJwt } from 'utils/functions/authentication';
import { authenticateUser, getLoginInfo } from './api';
import {
  fetchUserAuthenticationInfoSuccess,
  fetchUserAuthenticationInfoFail,
  fetchLoginInfoSuccess,
  fetchLoginInfoFail,
} from './actions';
import accountManagementActionTypes from './action-types';

function* authenticateUserSaga({ payload }) {
  try {
    const response = yield call(authenticateUser, payload);

    let returnURL = '/';
    if (Cookies.get('opsReturnURL')) returnURL = Cookies.get('opsReturnURL');
    let date = new Date(0);
    const expiryDate = parseJwt(response.data.token).exp;
    date = date.setUTCSeconds(expiryDate);
    const domain = getUpperLevelDomain();
    Cookies.set('veezAuth', response.data.token, {
      domain,
      expires: new Date(date),
    });

    document.location.href = returnURL;

    yield put(fetchUserAuthenticationInfoSuccess(response));
  } catch (error) {
    yield put(fetchUserAuthenticationInfoFail());
  }
}

function* getLoginInfoSaga({ payload }) {
  try {
    const response = yield call(getLoginInfo, payload);
    yield put(fetchLoginInfoSuccess(response));
  } catch (error) {
    const domain = getUpperLevelDomain();
    Cookies.remove('veezAuth', { domain });
    Cookies.remove('opsReturnURL');
    document.location.href = '/login';
    yield put(fetchLoginInfoFail());
  }
}

function* accountManagementSagas() {
  yield takeLatest(
    accountManagementActionTypes.FETCH_USER_AUTHENTICATION_INFO,
    authenticateUserSaga,
  );
  yield takeLatest(accountManagementActionTypes.FETCH_LOGIN_INFO, getLoginInfoSaga);
}

export default accountManagementSagas;
